export const CHANGE_STATE_FILTER = 'CHANGE_STATE_FILTER';
export const CHANGE_CITY_FILTER = 'CHANGE_CITY_FILTER';